import React, { useState, useEffect } from 'react';
import { Paper, Radio } from '@material-ui/core';
import styles from './lots.module.scss';
import { connect } from 'react-redux';
import { setLotWithModelSelected } from '../../../../../../redux/siteplanManagement/action';
import _ from 'lodash';

const Lots = (props) => {
	const {
		lotsList,
		lots,
		buildingInfo,
		modelKey,
		setPrice,
		setLotWithModelSelected,
		lotWithModelSelected,
		showAvailableLots,
		elevationRestriction,
		choseFromModel,
		modelLots,
		fitLots,
		coBrokerAssignedLots,
		filteredLots,
	} = props;
	const [selectedLot, setSelectedLot] = useState('');
	const [elevations, setElevations] = useState([]);
	const [selectedElevation, setSelectedElevation] = useState('');
	const [elevationsArr, setElevationsArr] = useState([]);
	const [lotsThatFitsModel, setLotsThatFitsModel] = useState([]);
	useEffect(() => {
		if (_.size(filteredLots) === 0) {
			setSelectedLot('');
			setElevations('');
			setLotWithModelSelected({});
		}
	}, [filteredLots]);
	useEffect(() => {
		var lotsToChoose;

		if (choseFromModel === true) {
			lotsToChoose = modelLots;
		} else {
			lotsToChoose = lotsList;
		}

		if (coBrokerAssignedLots.length > 0) {
			lotsToChoose = lotsToChoose?.filter((item) =>
				coBrokerAssignedLots.includes(item.lot)
			);
		}
	}, [lotsList, showAvailableLots, modelLots]);

	useEffect(() => {
		if (lotWithModelSelected?.modelName && lotWithModelSelected?.lotId) {
			if (lotWithModelSelected.modelName === modelKey) {
				setSelectedLot(lotWithModelSelected.lotId.toString());
			} else {
				setSelectedLot('');
			}
		}
	}, [lotWithModelSelected]);

	useEffect(() => {
		if (buildingInfo[modelKey]) {
			setElevations(buildingInfo[modelKey].priceList);
		}
	}, [buildingInfo, modelKey]);

	useEffect(() => {
		let elevationsResult = [];
		let filteredFitLots = fitLots.filter((fitLot) => fitLot[modelKey]);

		setLotsThatFitsModel(filteredFitLots);

		if (filteredFitLots.length > 0) {
			let elevationObj = filteredFitLots[0][modelKey];
			for (const elevation in elevationObj) {
				if (elevationObj[elevation].includes(Number(selectedLot))) {
					let filteredElevation = buildingInfo[
						modelKey
					].priceList.filter((price) => price.id === elevation);

					if (filteredElevation.length > 0) {
						elevationsResult.push(filteredElevation[0]);
					}
				}
			}
		}
		setElevationsArr(elevationsResult);
	}, [fitLots, modelKey, selectedLot]);

	useEffect(() => {
		if (
			lotWithModelSelected?.elevation?.id &&
			lotWithModelSelected?.lotId
		) {
			if (lotWithModelSelected.modelName === modelKey) {
				setSelectedElevation(lotWithModelSelected.elevation.id);
			} else {
				setSelectedElevation(buildingInfo[modelKey]?.priceList[0].id);
			}
		} else {
			setSelectedElevation(buildingInfo[modelKey]?.priceList[0].id);
		}
	}, []);

	useEffect(() => {
		if (selectedElevation) {
			const filteredElevation = buildingInfo[modelKey]?.priceList.filter(
				(item) => item.id === selectedElevation
			);
			if (filteredElevation?.length > 0) {
				setPrice(filteredElevation[0].price);
			}
		}
	}, [selectedElevation]);

	useEffect(() => {
		let lotWithModelSelected = {};

		if (
			selectedLot !== '' &&
			selectedElevation !== '' &&
			buildingInfo &&
			modelKey &&
			buildingInfo[modelKey]
		) {
			let lotInfo =
				(lotsList &&
					lotsList.filter(
						(item) => item.lot === Number(selectedLot)
					)[0]) ||
				(lots &&
					lots.filter((item) => item.lot === Number(selectedLot))[0]);
			let modelInfo = buildingInfo[modelKey];
			let elevationInfo = modelInfo?.priceList.filter(
				(item) => item.id === selectedElevation
			)[0];

			lotWithModelSelected = {
				lotId: lotInfo?.lot,
				availability: lotInfo?.availability,
				closingDate: lotInfo?.closingDate,
				lotPrice: lotInfo?.lotPrice,
				lotSize: lotInfo?.lotSize,
				lotSizeType: lotInfo?.lotSizeType,
				modelName: modelInfo?.name,
				modelSize: modelInfo?.sqft,
				elevation: elevationInfo,
				upgrade: lotInfo?.pricing ? lotInfo?.pricing[0] : '',
				grade: lotInfo?.pricing ? lotInfo?.pricing[1] : '',
			};

			setLotWithModelSelected(lotWithModelSelected);
		}
	}, [selectedLot, selectedElevation]);

	const handleLotChange = (e) => {
		setSelectedLot(e.target.value);
	};

	const handleElevationChange = (e) => {
		var data = e.currentTarget.dataset.elevation;
		setSelectedElevation(data);
	};

	return (
		<div className={styles.lots}>
			{filteredLots.length > 0 ? (
				filteredLots?.map((item) => {
					var elevationWithModel =
						lotsThatFitsModel['0'] &&
						lotsThatFitsModel['0'][modelKey];

					var elevationInModelKeys =
						elevationWithModel && Object.keys(elevationWithModel);

					var found = false;
					if (elevationInModelKeys) {
						elevationInModelKeys.forEach((elevKey) => {
							var elevationLots = elevationWithModel[elevKey];

							if (
								elevationLots.includes(
									Number(parseInt(item.lot))
								)
							) {
								found = true;
							}
						});
					}
					if (found) {
						return (
							<Paper
								className={styles.lots_paper}
								variant='outlined'
								key={item.lot}
							>
								<div className={styles.lots_header}>
									<p>Lot {item.lot}</p>
									<Radio
										checked={
											selectedLot === item.lot.toString()
										}
										onChange={handleLotChange}
										color='primary'
										name='selectedLot'
										value={item.lot}
										disabled={
											item.availability !== 'available'
										}
									/>
								</div>
								<div className={styles.lots_body}>
									${' '}
									{new Intl.NumberFormat('en-US').format(
										item.lotPrice
									)}
								</div>
								<div className={styles.lots_footer}>
									<p>{item.lotSize} SQFT</p>
									{item.availability === 'available' && (
										<div className={styles.lots_available}>
											Available
										</div>
									)}
									{item.availability === 'pending' && (
										<div className={styles.lots_pending}>
											Pending
										</div>
									)}
									{item.availability === 'soldout' && (
										<div className={styles.lots_soldout}>
											Sold out
										</div>
									)}
									{item.availability === 'hold' && (
										<div className={styles.lots_hold}>
											Hold
										</div>
									)}
								</div>
								{selectedLot === item.lot.toString() && (
									<div className={styles.lots_extra}>
										<p>Select Elevation</p>
										<div className={styles.elevations}>
											{!choseFromModel &&
												(elevations.length > 0 ? (
													elevations.map(
														(elevation) => {
															if (
																elevationRestriction[
																	elevation
																		?.id
																][
																	'canChoose'
																] === true
															) {
																return (
																	<div
																		className={`${
																			styles.elevation_btn
																		}  ${
																			selectedElevation ===
																			elevation.id
																				? styles.active
																				: ''
																		}`}
																		data-elevation={
																			elevation.id
																		}
																		onClick={(
																			e
																		) =>
																			handleElevationChange(
																				e
																			)
																		}
																		key={
																			elevation.id
																		}
																	>
																		{
																			elevation.id
																		}
																	</div>
																);
															}
														}
													)
												) : (
													<div
														className={
															styles.empty_state
														}
													>
														No elevations are
														available in this lot.
														{console.log(
															'Im here 223'
														)}
													</div>
												))}
											{choseFromModel &&
												(elevationsArr.length > 0 ? (
													elevationsArr.map(
														(elevation) => {
															return (
																<div
																	className={`${
																		styles.elevation_btn
																	}  ${
																		selectedElevation ===
																		elevation.id
																			? styles.active
																			: ''
																	}`}
																	data-elevation={
																		elevation.id
																	}
																	onClick={(
																		e
																	) =>
																		handleElevationChange(
																			e
																		)
																	}
																	key={
																		elevation.id
																	}
																>
																	{
																		elevation.id
																	}
																</div>
															);
														}
													)
												) : (
													<div
														className={
															styles.empty_state
														}
													>
														No elevations are
														available in this lot.
														{console.log(
															'Im here 263'
														)}
													</div>
												))}

											{console.log('afasdsfws', fitLots)}
										</div>
									</div>
								)}
							</Paper>
						);
					}
				})
			) : (
				<div className={styles.empty_state}>
					No lots are available in this model at this time.
				</div>
			)}
		</div>
	);
};

const mapStateToProps = (state) => ({
	buildingInfo: state.siteplanManagement.buildingInfo,
	lotWithModelSelected: state.siteplanManagement.lotWithModelSelected,
	showAvailableLots: state.siteplanManagement.showAvailableLots,
	fitLots: state.siteplanManagement.fitLots,
	coBrokerAssignedLots: state.siteplanManagement.coBrokerAssignedLots,
	lotSizeType: state.siteplanManagement.lotSizeType,
	filteredLots: state.siteplanManagement.filteredLots,
});

export default connect(mapStateToProps, {
	setLotWithModelSelected,
})(Lots);
